import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'apps',
  templateUrl: 'apps.html'
})
export class AppsComponent implements OnInit {

  usrApps = [];
  botones = [];

  @Output() onFlip: EventEmitter<String> = new EventEmitter<String>();

  constructor() {
    this.botones = [
      {index:0,img:'assets/imgs/miperfil.png',app:'assets/perfil.html', page:'Perfil'}, 
      {index:1,img:'assets/imgs/parking.png', app:'assets/parking.html', page:'Parking'}, 
      {index:2,img: 'assets/imgs/avisame.png',app:'assets/avisame.html', page:'Avisame'},  
      {index:3,img:'assets/imgs/buscame.png', app:'assets/buscame.html', page:'Buscame'}, 
      {index:4,img:'assets/imgs/distintivo.png', app:'assets/distintivo.html', page:'Distintivo'}, 
      {index:5,img:'assets/imgs/vidasabordo.png',app:'assets/vidasabordo.html', page:'VidasABordo'},  
      {index:6,img:'assets/imgs/micoche.png',app:'assets/micoche.html', page:'Test'}, 
      {index:7,img: 'assets/imgs/ayudame.png',app:'assets/ayudame.html', page:'Ayudame'}, 
      {index:8,img:'assets/imgs/112.png',app:'assets/112.html', page:'112'}
    ];

  }
  ngOnInit() {}

  flip(boton){
    console.log("flip app: ", this.botones[boton.index]);
    this.onFlip.next(boton);
  }

}



// WEBPACK FOOTER //
// ./src/components/apps/apps.ts